import React from "react";
import { FiArrowRight } from "react-icons/fi";

import Chart from "components/MI/minha-conta/Chart";
import TourBalloon from "components/NewTour/TourBallon";

import {
  BodySpending,
  ButtonBills,
  ContainerWrap,
  ContentSpending,
  FooterSpeding,
  HeaderCard,
  TitleCard,
} from "./PortalPage.styles";

type Props = {
  showTour: boolean;
  spending: any;
  tourStep: number;
  tourType: string;
};

const PortalSpendPanel = ({
  spending,
  showTour,
  tourStep,
  tourType,
}: Props): JSX.Element => {
  const highlight = tourStep === 7 && tourType === "home" && showTour;

  return (
    <ContentSpending showTour={highlight}>
      <ContainerWrap>
        <HeaderCard>
          <TitleCard>Comparação de consumo (Kg)</TitleCard>
        </HeaderCard>
        <BodySpending>
          {spending?.length ? (
            <Chart data={spending} />
          ) : (
            <span>Não se preocupe! No primeiro mês não virá a conta.</span>
          )}
        </BodySpending>
        <FooterSpeding>
          <ButtonBills to="consumo">
            <span>Ver todos</span>
            <FiArrowRight />
          </ButtonBills>
        </FooterSpeding>
      </ContainerWrap>
      {showTour && tourStep === 7 && tourType === "home" && (
        <TourBalloon
          title="Comparação de consumo"
          content="Aqui você tem um comparativo de seu consumo do mês anterior, em relação ao mês atual."
          position={{
            left: "0",
            right: "0",
            top: "128px",
            arrowPosition: "top",
            maxWidth: 320,
            arrowTop: "-28px",
          }}
        />
      )}
    </ContentSpending>
  );
};

export default PortalSpendPanel;
